import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Convert a UTC ISO string to the "YYYY-MM-DDTHH:mm" format that
 * <input type="datetime-local"> expects, in the user's local timezone.
 * Slicing the raw ISO string would show UTC time as if it were local.
 */
export function toLocalDatetimeInput(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * Convert a "YYYY-MM-DDTHH:mm" local datetime-input value back into a
 * UTC ISO string for the API. Returns null for empty input.
 */
export function fromLocalDatetimeInput(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  if (isNaN(d.getTime())) return null;
  return d.toISOString();
}
